import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchDocuSignEnvelopesQuery,
  Flex_FetchDocuSignEnvelopesQueryVariables,
} from '~/typings/graphql';
import { docusignRedirectUrl } from '~/utils/redirects';
import { FETCH_DOCU_SIGN_ENVELOPES } from './fetch-docu-sign-envelopes.queries';

interface FetchDocuSignEnvelopesParams {
  userId: number;
  returnUrl?: string;
}
export interface FetchDocuSignEnvelopesResponse {
  docuSignEnvelopes: {
    id: number;
    status?: string | null;
    url?: string | null;
  }[];
}

export const fetchDocuSignEnvelopes = async (
  params: FetchDocuSignEnvelopesParams,
): Promise<FetchDocuSignEnvelopesResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchDocuSignEnvelopesQuery,
    Flex_FetchDocuSignEnvelopesQueryVariables
  >({
    fetchPolicy: 'no-cache', // machine polls this query
    query: FETCH_DOCU_SIGN_ENVELOPES,
    variables: {
      returnUrl: params.returnUrl || docusignRedirectUrl(),
      userId: params.userId,
    },
  });

  const { docuSignEnvelopes } = data.user;

  return {
    docuSignEnvelopes,
  };
};
